import { LastSearch } from './last-search';
export class LastSearches {

  private username: String;
  lastSearchList: Array<LastSearch>;

  constructor() {
    this.lastSearchList = new Array<LastSearch>();
  }

  /**
   * Getter username
   * @return {String}
   */
  public getUsername(): String {
    return this.username;
  }

  /**
   * Setter username
   * @param {String} value
   */
  public setUsername(value: String) {
    this.username = value;
  }

  /**
   * Getter lastSearchList
   * @return {Array<LastSearch>}
   */
  public getLastSearchList(): Array<LastSearch> {
    return this.lastSearchList;
  }

  /**
   * Setter lastSearchList
   * @param {Array<LastSearch>} value
   */
  public setLastSearchList(value: Array<LastSearch>) {
    this.lastSearchList = value;
  }

}


// WEBPACK FOOTER //
// ./src/app/shared/model/last-searches.ts